export const FRONTEND_SERVER = process.env.FRONTEND_SERVER
export const BACKEND_SERVER = process.env.BACKEND_SERVER
export const ACUMATICA_CLIENT_ID = process.env.ACUMATICA_CLIENT_ID
export const ACUMATICA_REDIRECT_URI = process.env.ACUMATICA_REDIRECT_URI
export const ACUMATICA_INSTANCE_URL = process.env.ACUMATICA_INSTANCE_URL
export const ACUMATICA_SCOPE = process.env.ACUMATICA_SCOPE
export const FRONTEND_PORT = process.env.FRONTEND_PORT